import type { LessonCreateStore } from './interfaces'

export const createLessonCreateState = (): LessonCreateStore => ({
  loading: false,
  slots: null,
  type: null,
  today: '',
  date: '',
  startTime: '',
  duration: null,
  tutorId: null,
  appliedFilters: null,
  tutorModalOpen: false,
  saving: false,
})
